export function ShieldIconDrawn({
  className,
  shieldNumber,
}: {
  className?: string;
  shieldNumber: 1 | 2;
}) {
  return (
    <img
      className={className}
      src={__RUNTIME.baseUrl + `/images/shield${shieldNumber}.png`}
      alt="Щит со статистикой игрока"
    />
  );
}
